import { 
  CORES_SITE, 
  TIPOGRAFIA, 
  CONTAINERS, 
  BORDAS_DESTAQUE,
  ESPACAMENTO,
  TRANSICOES
} from '../../data/visualConstants';

interface ComparacaoSalariosProps {
  salarioUsuario: number;
  comparacaoDeputado: number;
  comparacaoMagistrado: number;
  salarioMagistradoEstado: number; 
}

const formatarMoeda = (valor: number): string => {
  return `R$ ${valor.toLocaleString('pt-BR')}`;
};

export const ComparacaoSalarios = ({ 
  salarioUsuario, 
  comparacaoDeputado, 
  comparacaoMagistrado,
  salarioMagistradoEstado 
}: ComparacaoSalariosProps) => {
  
  const dados = [
    {
      cargo: 'Deputado Federal',
      salario: 46366,
      percentual: comparacaoDeputado,
      cor: CORES_SITE.VERMELHO_PRIMARY,
      bordaDestaque: BORDAS_DESTAQUE.VERMELHO
    },
    {
      cargo: 'Magistrado Estadual',
      salario: salarioMagistradoEstado, 
      percentual: comparacaoMagistrado,
      cor: CORES_SITE.AMARELO_DESTAQUE,
      bordaDestaque: BORDAS_DESTAQUE.DOURADO
    }
  ];

  return (
    <div className={`${CONTAINERS.CARD_BASE} ${ESPACAMENTO.CARD_PADDING_GRANDE}`}>
      {/* Barras horizontais com proporção correta */}
      <div className="space-y-8">
        {dados.map((item) => (
          <div key={item.cargo} className="relative">
            {/* Label do cargo e valor */}
            <div className="flex justify-between items-center mb-3">
              <span className={TIPOGRAFIA.SUBTITULO}>
                {item.cargo}
              </span>
              <span className={TIPOGRAFIA.VALOR_DESTAQUE_PEQUENO} style={{ color: item.cor }}>
                {formatarMoeda(item.salario)}
              </span>
            </div>
            
            {/* Barra de progresso com escala correta */}
            <div className="relative mb-2">
              <div className="w-full bg-gray-200 rounded-full h-4">
                <div 
                  className={`h-4 rounded-full ${TRANSICOES.LENTA}`}
                  style={{ 
                    width: `${Math.min(100, item.percentual)}%`,
                    backgroundColor: item.cor
                  }}
                />
              </div>
            </div>
            
            {/* Texto de comparação */}
            <div className="mt-2">
              <span className={TIPOGRAFIA.LABEL_PEQUENO} style={{ color: item.cor }}>
                {item.percentual}% do salário deste cargo
              </span>
            </div>
          </div>
        ))}
      </div>
      
      {/* Cards resumo na parte inferior */}
      <div className="grid sm:grid-cols-2 gap-4 mt-8 pt-6 border-t border-gray-200">
        <div className={`${CONTAINERS.CARD_BASE} ${BORDAS_DESTAQUE.VERMELHO} ${ESPACAMENTO.CARD_PADDING} text-center`}>
          <p className={TIPOGRAFIA.LABEL_MEDIO}>Deputado Federal</p>
          <p className={TIPOGRAFIA.VALOR_DESTAQUE_MEDIO} style={{ color: CORES_SITE.VERMELHO_PRIMARY }}>
            {comparacaoDeputado}%
          </p>
          <p className={TIPOGRAFIA.LEGENDA}>
            Você recebe {comparacaoDeputado}% do salário de um <strong>deputado federal</strong>
          </p>
        </div>
        
        <div className={`${CONTAINERS.CARD_BASE} ${BORDAS_DESTAQUE.DOURADO} ${ESPACAMENTO.CARD_PADDING} text-center`}>
          <p className={TIPOGRAFIA.LABEL_MEDIO}>Magistrado Estadual</p>
          <p className={TIPOGRAFIA.VALOR_DESTAQUE_MEDIO} style={{ color: CORES_SITE.AMARELO_DESTAQUE }}>
            {comparacaoMagistrado}%
          </p>
          <p className={TIPOGRAFIA.LEGENDA}>
            Você recebe {comparacaoMagistrado}% do salário de um <strong>magistrado estadual</strong>
          </p>
        </div>
      </div>
    </div>
  );
}